module.exports = __webpack_public_path__ + "23a8223725c0afc019feda7db083e815.riv";